module.exports = __webpack_public_path__ + "static/img/gongyinglian-top.422f802a.png";